import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostTruncateChainProps {
    token: string;
    chain: string;
}

export const postTruncateChain: MutationFunction<
    AxiosResponse<any>,
    PostTruncateChainProps
> = async (props: PostTruncateChainProps) => {
    const { token, chain } = props;
    const headers = getDefaultHeaders(token);
    const truncateChainJobUrl = `/jobs/${chain}/truncate`;

    return axiosInstance().post(
        truncateChainJobUrl,
        { chain },
        withHeaders(headers)
    );
};

export const useTruncateChain = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostTruncateChainProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postTruncateChain, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create truncate chain job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
